<template>
  <!-- Future Self: Sorry for the inline styles, but the admin template stylesheet overwrites ANY margins and paddings with 0 :/ -->
  <mia-notice
    v-bind="attrs"
    class="relative transition-colors duration-300 ease-out"
    v-on="$listeners"
  >
    <div
      class="absolute top-0 left-0 overflow-hidden transition-all duration-300 ease-out fill-current"
      :class="{
        'w-0': !done,
        'w-12': done
      }"
      style="top: 0.75rem; left: 0.75rem;"
    >
      <mia-streamline-icon
        class="w-6 h-6 text-green-600"
        src="check-circle-1"
      />
    </div>

    <div
      class="transition-all duration-300 ease-out hover:opacity-100"
      :class="{ 'opacity-50': done }"
      :style="{
        paddingLeft: `${done ? 2 : 0}rem`
      }"
    >
      <slot />
    </div>
  </mia-notice>
</template>

<script>
import Notice from '@/components/cars/edit/Notice.vue'

export default {
  name: 'MiaInstruction',

  components: {
    'mia-notice': Notice
  },

  props: {
    done: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    attrs() {
      return {
        ...this.$attrs,
        permanent: true,
        type: this.done ? 'success' : 'info'
      }
    }
  }
}
</script>
